export const defaultPinBagIconUrl = process.env.REACT_APP_PIN_ICON
